/**
 * Colours for the world-graph screens, kept here so the rest of the app's
 * theme is untouched. One colour per team, assigned in the order owners first
 * appear in the stock list, so a team keeps its colour across screens.
 */
export const POSITIVE = '#15803d'
export const NEGATIVE = '#b91c1c'
export const SELECTED = '#162B4B'

export const OWNER_PALETTE = [
  '#2563eb',
  '#d97706',
  '#7c3aed',
  '#0d9488',
  '#db2777',
  '#65a30d',
]

export function ownerColorsFrom(
  nodes: { owner?: string | null }[]
): Map<string, string> {
  const owners = Array.from(
    new Set(nodes.map((n) => n.owner).filter(Boolean))
  ) as string[]
  const colors = new Map<string, string>()
  owners.forEach((owner, index) => {
    colors.set(owner, OWNER_PALETTE[index % OWNER_PALETTE.length])
  })
  return colors
}
